import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state: {
        cacheImage:'', //  缓存的图片对象键值对 （转成 jsonString 存储）
        userInfo: undefined,
        shoppingCart: undefined,
        token:'',
        tokenExpireTime:0,
        checkEmail: ''
    },
    getters:{
        getCacheImage(state){
            return state.cacheImage
        },
        getUserInfo(state) {
            return function (...apilist){
                return (
                    apilist.filter((route) => {
                        return state.permission.includes(route);
                    }).length > 0
                );
            }
        },
        getTokenExpireTime(state){
            return function (...apilist){
                return (
                    apilist.filter((route) => {
                        return state.permission.includes(route);
                    }).length > 0
                );
            }
        }
    },
    // 修改数据的地方
    mutations: {
        saveCacheImage(state,newval){
            state.cacheImage = newval
        },
        // 清空缓存信息
        clearCacheImage(){
            state.cacheImage = ''
        },
        saveUserInfo(state,newVal) {
            state.userInfo = newVal;
        },
        saveLoginToken(state, newVal){
            state.token = newVal
        },
        saveTokenExpireTime(state,time){
            state.tokenExpireTime = time
        },
        saveCheckedEmail(state,newval){
            state.checkEmail = newval
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js